import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';
import { settlePaymentIntentKeyForTransaction } from '@/lib/paymentSafety';

export interface CancelUnsubmittedPaymentResult {
  status: string;
  transaction_id: string;
  reason?: string;
  terminal?: boolean;
  retryable?: boolean;
}

export async function cancelUnsubmittedPayment(
  client: SupabaseClient<Database>,
  transactionId: string,
): Promise<CancelUnsubmittedPaymentResult> {
  const { data, error } = await client.functions.invoke('verify-payment', {
    body: { transaction_id: transactionId, action: 'cancel_unsubmitted' },
  });
  if (error) throw error;
  const result = data as CancelUnsubmittedPaymentResult;
  if (result?.terminal) {
    settlePaymentIntentKeyForTransaction(transactionId, result.status);
  }
  return result;
}
